import { render, staticRenderFns } from "./SettingsRegistry.vue?vue&type=template&id=ef31a080&scoped=true"
import script from "./SettingsRegistry.vue?vue&type=script&lang=js"
export * from "./SettingsRegistry.vue?vue&type=script&lang=js"
import style0 from "./SettingsRegistry.vue?vue&type=style&index=0&id=ef31a080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef31a080",
  null
  
)

export default component.exports